import { render, staticRenderFns } from "./CompanyprofileRight.vue?vue&type=template&id=f840563c&scoped=true&"
import script from "./CompanyprofileRight.vue?vue&type=script&lang=js&"
export * from "./CompanyprofileRight.vue?vue&type=script&lang=js&"
import style0 from "./CompanyprofileRight.vue?vue&type=style&index=0&id=f840563c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f840563c",
  null
  
)

export default component.exports